<template>


	<div id='body'>

		<img src="http://m.top917.cn/special/wxyyx/images/01.jpg" />
		<div style="margin: auto 0.5rem;background-color:#fff; border-radius: 10px; margin-bottom:0.5rem">
			<form @submit.prevent="submit">
				<div style="margin: 0 0.5rem;">
					<img src="http://m.top917.cn/special/wxyyx/images/03.jpg"/>
					<div class="input" style="">
						<img class="formimg" src="http://m.top917.cn/special/wxyyx/images/01.png" style="width: 5%;"/>
						<input name="mobile" type="text" v-model="user_phone" placeholder="请输入您的手机号码">
						<div style="clear:both"></div>
					</div>
					<div style="height:0.25rem"></div>

					<div class="input" style="">
						<img class="formimg" src="http://m.top917.cn/special/wxyyx/images/02.png" style="width: 5%;"/>
						<input name="name" type="text" v-model="user_name" placeholder="您的姓名">
						<div style="clear:both"></div>
					</div>
					<div style="height:0.25rem"></div>


					<div class="input" style="">
						<img class="formimg" src="http://m.top917.cn/special/wxyyx/images/03.png" style="width: 5%;"/>
						<select id="ddlSelect"  class="" @change="set_where()" v-model="user_xuanmu" autocomplete="off" style="width: 66%;position:absolute;height:50px;opacity:0;">
							<option value="0">请选择预约项目</option>
							<option value="1">洗牙</option>
							<option value="1">补牙</option>
							<option value="2">拔牙</option>
							<option value="3">整牙</option>
							<option value="4">种牙</option>
							<option value="5">儿童牙齿</option>
							<option value="6">其它</option>
						</select>
						<input name="class" class="xiangmu" id="ddlSelect_value" ref="xiangmu_option" type="text" placeholder="预约项目" >
						<img src="http://m.top917.cn/special/wxyyx/images/11.jpg" style="width: 7%;float:right"/>
						<div style="clear:both"></div>
					</div>
					<div style="height:0.25rem"></div>


					<div class="input" style="">
						<img class="formimg" src="http://m.top917.cn/special/wxyyx/images/04.png" style="width: 5%;"/>
						<select id="ddlSelect1" class="time_option"  @change="set_time()" v-model="user_yutime" autocomplete="off" style="width: 66%;position:absolute;height:50px;opacity:0;">
							<option value="0">请选择预约时间</option>
							<option value="1">上午</option>
							<option value="2">下午</option>
						</select>
						<input name="yuyue_time" class="yuyue_time" id="ddlSelect1_value" type="text" placeholder="预约时间（上午或下午）" >
						<img src="http://m.top917.cn/special/wxyyx/images/11.jpg" style="width: 7%;float:right"/>
						<div style="clear:both"></div>
					</div>
					<div style="height:0.25rem"></div>


					<div class="input" style="">
						<img class="formimg" src="http://m.top917.cn/special/wxyyx/images/03.png" style="width: 5%;"/>
						<select id="ddlSelect2" class="mengzneng_option" @change="set_addr()" v-model="user_address" autocomplete="off" style="width: 66%;position:absolute;height:50px;opacity:0;">
							<option value="0">请选择预约门诊</option>
							<option value="1">罗湖区</option>
							<option value="1">南山区</option>
							<option value="2">福田区</option>
							<option value="3">宝安区</option>
							<option value="4">龙岗区</option>
							<option value="5">龙华新区</option>
						</select>
						<input name="yuyue_diqu" class="diqu yuyueaddr" id="ddlSelect2_value" type="text" placeholder="预约门诊（龙岗或南山等）">
						<img src="http://m.top917.cn/special/wxyyx/images/11.jpg" style="width: 7%;float:right"/>
						<div style="clear:both"></div>
					</div>

					<div style="height:0.25rem"></div>




					<div class="sub" @click="submit">提交</div>
					<div style="height:0.5rem"></div>
				</div>
			</form>
		</div>

		<div style="margin: auto 0.5rem;background-color:#fff; border-radius: 10px; margin-bottom:0.5rem">
			<div style="margin: 0 0.5rem;">
				<img src="http://m.top917.cn/special/wxyyx/images/04.jpg" />
			</div>
		</div>

		<div style="margin: auto 0.5rem;background-color:#fff; border-radius: 10px; margin-bottom:0.5rem">
			<div style="margin: 0 0.5rem;">
				<img src="http://m.top917.cn/special/wxyyx/images/05.jpg" />
				<img src="http://m.top917.cn/special/wxyyx/images/06.jpg" />
				<img src="http://m.top917.cn/special/wxyyx/images/07.jpg" />
			</div>
		</div>

		<div style="margin: auto 0.5rem;background-color:#fff; border-radius: 10px;">
			<div style="margin: 0 0.5rem;">
				<img src="http://m.top917.cn/special/wxyyx/images/08.jpg" />
			</div>
		</div>
		<div style="height:0.5rem;background-color:#d7f1f0"></div>
	</div>



</template>
<script>

    import "@assets/css/swiper.min.css";
    import "@assets/css2/style.css";
    import "@assets/css2/yuyue.css";
    import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
    import { validatorDefaultCatch } from "@utils/dialog";
    import { postYuyueAdd } from "@api/store";

    export default {
        name: "huodong_list",
        props: {},
        data: function() {
            return {
                page: 1,
                limit: 20,
                loadTitle: "",
                user_phone: "",
                user_name: "",
                loadend: false,
            };
        },
        mounted: function() {
            // this.articleBanner();
            // this.articleCategory();
            // this.articleHotList();

        },
        methods: {
            async submit() {
                var that = this;
                const { user_phone, user_name ,user_xuanmu,user_yutime,user_address} = that;
                try {
                    await this.$validator({
                        user_phone: [
                            required(required.message("手机号码")),
                            chs_phone(chs_phone.message())
                        ]
                    }).validate({ user_phone });
                } catch (e) {
                    return validatorDefaultCatch(e);
                }

                var data = {};
                data.user_phone = user_phone;
                data.user_name = user_name;
                data.user_xuanmu = user_xuanmu;
                data.user_yutime = user_yutime;
                data.user_address = user_address;
                postYuyueAdd(data)
                    .then(res => {
                        that.$dialog.toast({
                            mes: res.msg,
                        });
                    })
                    .catch(res => {
                        this.$dialog.error(res.msg);
                    });
                // postYuyueAdd({ user_phone, user_name ,user_xuanmu,user_yutime,user_address })
                // 	  .then(({ data }) => {
                // 	  	console.log(data);
                // 		  // this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
                // 		  // const backUrl = cookie.get(BACK_URL) || "/";
                // 		  // cookie.remove(BACK_URL);
                // 		  // this.$router.replace({ path: backUrl });
                // 	  })
                // 	  .catch(e => {
                // 		  this.$dialog.error(e.msg);
                //   });
            },
            set_where: function() {
                let province_ = document.getElementById('ddlSelect');
                let province_value = province_.options[province_.selectedIndex].text;
                document.getElementById('ddlSelect_value').setAttribute('placeholder', province_value)
            },
            set_time: function() {
                let province_ = document.getElementById('ddlSelect1');
                let province_value = province_.options[province_.selectedIndex].text;
                document.getElementById('ddlSelect1_value').setAttribute('placeholder', province_value)
            },
            set_addr: function() {
                let province_ = document.getElementById('ddlSelect2');
                let province_value = province_.options[province_.selectedIndex].text;
                document.getElementById('ddlSelect2_value').setAttribute('placeholder', province_value)
            }
                // switch (index) {
                //     case 1:
                //          province_ =  document.getElementById('ddlSelect');
                //         textval= province_.options[province_.selectedIndex].text;
                //        	console.log(that);
                //        	console.log(textval);
                //         // that.result1 = this.$refs.input1.value + " 成功!";
                //         break;
                //     case 2:
                //          province_ =  document.getElementById('ddlSelect1');
                //         break;
                //     case 3:
                //          province_ =  document.getElementById('ddlSelect2');
                //         break;
                // }
        }
    };
</script>
